import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Historic from './components/Historic';
import OrderDetail from './components/OrderDetail';
import Login from './components/Login';
import Home from './components/Home';
import BuyOrderList from './components/BuyOrderList';
import Layout from './components/Layout';
import SalesOrderDetail from './components/SalesOrderDetail';
import CreateASN from './components/CreateASN';
import ASNList from './components/ASNList';
import ASNDetail from './components/ASNDetail';
import ASNDraft from './components/ASNDraft';
import UserList from './components/UserList';
import EditASN from './components/EditASN';
import OrderList from './pages/orderlist';
import NotificationsList from './pages/notificationslist';
import RampsList from './pages/rampslist';
import Users from './pages/users';
import Trucks from './pages/trucks';
import Sending from './pages/sendinglist';
import TruckTypes from './pages/truck-types';
import Districts from './pages/districts';
import Centers from './pages/centers';
import Warehouse from './pages/warehouse';
import Company from './pages/company';
import Suppliers from './pages/suppliers';
import ExamplePage from './components/ExamplePage';
import Ramplist from './components/virtualRamp/RampList';
import RampDetail from './components/virtualRamp/RampDetail';
import CreateRamp from './components/virtualRamp/CreateRamp';
import { ScheduleList } from './components/appoiment/ScheduleList';
import CreateAssignment from './components/virtualRamp/CreateAssignment';
import RoleList from './components/Role/RoleList';
import RoleForm from './components/Role/RoleForm';
import PermissionGuard from './components/PermissionGuard';
import SaasAdminGuard from './components/SaasAdminGuard';
import AccessDenied from './components/AccessDenied';
import AdminTenants from './pages/adminTenants';
import SystemConfig from './components/systemConfig/SystemConfig';
import ResetPassword from './components/ResetPassword';
import Brandings from './pages/brandings';
import SaleChannels from './pages/sale-channels';
import SalesOrders from './pages/sales-orders';
import ShippingMethods from './pages/shipping-methods';

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas - sin protección */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Vista combinada OC/OV: alcanza con tener uno de los dos permisos
            (BuyOrderList alterna pestañas según `?view=` y permisos). */}
        <Route path="/buy-order-list" element={
          <PermissionGuard
            requiredAnyOf={['buyorder', 'salesorder']}
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Layout>
              <BuyOrderList />
            </Layout>
          </PermissionGuard>
        } />
        
        <Route path="/historic" element={
          <PermissionGuard 
            requiredPermission="buyorder" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Historic />
          </PermissionGuard>
        } />
        
        <Route path="/order-detail/:id" element={
          <PermissionGuard 
            requiredPermission="buyorder" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <OrderDetail />
          </PermissionGuard>
        } />

        {/* OV: `SalesOrderDetail` + `services/salesOrdersList` (GET order-number/:id). :id = número de orden negocio. */}
        <Route path="/sales-order-detail/:id" element={
          <PermissionGuard
            requiredPermission="salesorder"
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <SalesOrderDetail />
          </PermissionGuard>
        } />
        
        <Route path="/orderlist" element={
          <PermissionGuard
            requiredPermission="buyorder"
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <OrderList />
          </PermissionGuard>
        } />

        {/* Historial de Órdenes de Venta */}
        <Route path="/sales-orders" element={
          <PermissionGuard
            requiredPermission="salesorder"
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <SalesOrders />
          </PermissionGuard>
        } />

        {/* Módulo de notificaciones (notification) */}
        <Route path="/create-asn/:id" element={
          <PermissionGuard 
            requiredPermission="notification" 
            requiredAction="create"
            fallback={<AccessDenied />}
          >
            <CreateASN />
          </PermissionGuard>
        } />
        
        <Route path="/asn-list" element={
          <PermissionGuard 
            requiredPermission="notification" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <ASNList />
          </PermissionGuard>
        } />
        
        <Route path="/asn/:id" element={
          <PermissionGuard 
            requiredPermission="notification" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <ASNDetail />
          </PermissionGuard>
        } />
        
        <Route path="/edit-asn/:id" element={
          <PermissionGuard 
            requiredPermission="notification" 
            requiredAction="update"
            fallback={<AccessDenied />}
          >
            <EditASN />
          </PermissionGuard>
        } />
        
        <Route path="/asn-draft/:id" element={
          <PermissionGuard 
            requiredPermission="notification" 
            requiredAction="update"
            fallback={<AccessDenied />}
          >
            <ASNDraft />
          </PermissionGuard>
        } />
        
        <Route path="/notificationslist" element={
          <PermissionGuard 
            requiredPermission="notification" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <NotificationsList />
          </PermissionGuard>
        } />

        {/* Módulo de rampas virtuales (virtualramp) */}
        <Route path="/ramp/:id" element={
          <PermissionGuard 
            requiredPermission="virtualramp" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <RampDetail />
          </PermissionGuard>
        } />
        
        <Route path="/create-ramp" element={
          <PermissionGuard 
            requiredPermission="virtualramp" 
            requiredAction="create"
            fallback={<AccessDenied />}
          >
            <CreateRamp />
          </PermissionGuard>
        } />
        
        <Route path="/create-assignment/:id" element={
          <PermissionGuard 
            requiredPermission="virtualramp" 
            requiredAction="update"
            fallback={<AccessDenied />}
          >
            <CreateAssignment />
          </PermissionGuard>
        } />

        {/* Módulo de agendamientos (schedules) */}
        <Route path="/schedule-list" element={
          <PermissionGuard 
            requiredPermission="schedules" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <ScheduleList />
          </PermissionGuard>
        } />

        {/* Módulo de usuarios (users) */}
        <Route path="/user-list" element={
          <PermissionGuard 
            requiredPermission="users" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <UserList />
          </PermissionGuard>
        } />
        
        <Route path="/users" element={
          <PermissionGuard 
            requiredPermission="users" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Users />
          </PermissionGuard>
        } />

        {/* Módulo de roles (roles) */}
        <Route path="/roles" element={
          <PermissionGuard 
            requiredPermission="roles" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <RoleList />
          </PermissionGuard>
        } />
        
        <Route path="/roles/create" element={
          <PermissionGuard 
            requiredPermission="roles" 
            requiredAction="create"
            fallback={<AccessDenied />}
          >
            <RoleForm />
          </PermissionGuard>
        } />
        
        <Route path="/roles/edit/:id" element={
          <PermissionGuard 
            requiredPermission="roles" 
            requiredAction="update"
            fallback={<AccessDenied />}
          >
            <RoleForm />
          </PermissionGuard>
        } />

        {/* Módulo de camiones (trucks) */}
        <Route path="/trucks" element={
          <PermissionGuard 
            requiredPermission="trucks" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Trucks />
          </PermissionGuard>
        } />

        {/* Módulo de tipos de camiones (truckstypes) */}
        <Route path="/truck-types" element={
          <PermissionGuard 
            requiredPermission="truckstypes" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <TruckTypes />
          </PermissionGuard>
        } />

        {/* Módulo de distritos (district) */}
        <Route path="/districts" element={
          <PermissionGuard 
            requiredPermission="district" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Districts />
          </PermissionGuard>
        } />

        {/* Módulo de centros (centers) */}
        <Route path="/centers" element={
          <PermissionGuard 
            requiredPermission="centers" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Centers />
          </PermissionGuard>
        } />

        {/* Módulo de bodegas (warehouses) */}
        <Route path="/warehouses" element={
          <PermissionGuard 
            requiredPermission="warehouses" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Warehouse />
          </PermissionGuard>
        } />

        {/* Módulo de métodos de envío (shippingmethod) */}
        <Route path="/shipping-methods" element={
          <PermissionGuard
            requiredPermission="shippingmethod"
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <ShippingMethods />
          </PermissionGuard>
        } />

        {/* Módulo de compañías (companies) */}
        <Route path="/companies" element={
          <PermissionGuard 
            requiredPermission="companies" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Company />
          </PermissionGuard>
        } />

        {/* Módulo de compañías (companies) */}
        <Route path="/ramplas" element={
          <PermissionGuard 
            requiredPermission="virtualramp" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <RampsList />
          </PermissionGuard>
        } />

        {/* Módulo de compañías (companies) */}
        <Route path="/sending" element={
          <PermissionGuard 
            requiredPermission="virtualramp" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Sending />
          </PermissionGuard>
        } />

        {/* Módulo de configuración del sistema (settings) */}
        <Route path="/system-config" element={
          <PermissionGuard 
            requiredPermission="settings" 
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <SystemConfig />
          </PermissionGuard>
        } />

        {/* Módulo de Brandings */}
        <Route path="/brandings" element={
          <PermissionGuard
            requiredPermission="branding"
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <Brandings />
          </PermissionGuard>
        } />

        {/* Módulo de Canales de Venta */}
        <Route path="/sale-channels" element={
          <PermissionGuard
            requiredPermission="saleschannel"
            requiredAction="listView"
            fallback={<AccessDenied />}
          >
            <SaleChannels />
          </PermissionGuard>
        } />

        {/* Módulo de administración de plataforma - Solo SaaS Admin */}
        <Route path="/admin/tenants" element={
          <SaasAdminGuard fallback={<AccessDenied />}>
            <AdminTenants />
          </SaasAdminGuard>
        } />

        {/* Rutas provisionales - No protegidas por ahora */}
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/scheduling" element={<ExamplePage />} />
        <Route path="/import-orders" element={<ExamplePage />} />
        <Route path="/assignment-history" element={<ExamplePage />} />
        <Route path="/tasks" element={<ExamplePage />} />
        <Route path="/permissions" element={<ExamplePage />} />
      </Routes>
    </Router>
  );
}

export default App;
